import React, { ChangeEventHandler, FocusEventHandler, KeyboardEventHandler } from "react";

export interface SaneInputProps {
    value?: string;

    /* Analogous to HTML onChange, but not React's onChange, which is batshit insane. */
    onCommit : (value: string) => void; 
}

export interface SaneInputState {
    value: string;
}

/* React's form elements are whack, yo. */
export class SaneInput extends React.Component<SaneInputProps, SaneInputState> {    
    constructor(props: Readonly<SaneInputProps>) {
        super(props);
        this.state = {
            value: this.props.value ?? ""
        };
    }

    public render = () => {
        return <input onBlur={this.onBlur} onKeyDown={this.onKeyDown} onChange={this.onChange} value={this.state.value}></input>
    }

    onBlur: FocusEventHandler<HTMLInputElement> 
    = (ev) => {
        this.props.onCommit(this.state.value);
    }

    onKeyDown: KeyboardEventHandler<HTMLInputElement> 
    = (ev) => {
        if ('Enter'===ev.key) {
            this.props.onCommit(this.state.value);
        }
    }
    
    onChange: ChangeEventHandler<HTMLInputElement>
    = (ev) => {
        this.setState({value: ev.target.value})
    }
}